import {BaseStoreItem} from '../BaseStoreItem'
import {StoreConsumable, StoreItemCategory} from '../../entity_datas/StoreEnums'
import {LobbyImage} from '@colonist/types'
import {TranslationObject, TranslationArrayKeys} from '@colonist/i18n'

export class SIUsernameChange extends BaseStoreItem {
    category = StoreItemCategory.Consumable
    type = StoreConsumable.UsernameChange
    name: TranslationObject = {key: 'strings:storePage.consumables.usernameChange.title'}
    description: TranslationArrayKeys = 'strings:storePage.consumables.usernameChange.description'
    price = 1300
    image = LobbyImage.Guest
}
